import React from "react";
import "./execute.css";
import { useEffect } from "react";
import apiLink, { publicRequest } from "../../api/apiLink";
import { useSelector } from "react-redux";
import Loader from "../../components/common/Loader";

export default function PayStationExecute() {
  const urlParams = new URLSearchParams(window.location.search);
  const invoiceNumber = urlParams.get("invoice_number");
  const trxID = urlParams.get("trx_id");
  const status = urlParams.get("status");

  const userData = useSelector(
    (state) => state.persistedReducer.auth?.currentUser?.customer,
  );

  // reseller data
  const resellerData = useSelector(
    (state) => state.persistedReducer.auth?.userData,
  );

  if (!invoiceNumber || !trxID) {
    window.location.href = "/payment/failed";
  }

  const paymentExecute = async () => {
    let URL = {
      execute: "customer/payStation/payment/execute",
      baseURL: apiLink,
    };

    if (resellerData.id) {
      URL = {
        execute: "reseller/payStation/payment/execute",
        baseURL: apiLink,
      };
    } else if (!userData) {
      URL = {
        execute: "customer/payStation/payment/execute",
        baseURL: publicRequest,
      };
    }

    const ispOwnerId = userData
      ? userData.ispOwner.id
      : sessionStorage.getItem("qrispid");

    return await URL.baseURL.post(
      `${URL.execute}?invoice_number=${invoiceNumber}&trx_id=${trxID}&status=${status}&reseller=${resellerData.id}`,
      {
        ispOwner: ispOwnerId,
      },
    );
  };

  useEffect(() => {
    paymentExecute()
      .then((response) => {
        if (response?.data?.bill?.paymentStatus === "paid") {
          sessionStorage.removeItem("qrispid");
          window.location.href = "/payment/success";
        } else if (response?.data?.resellerRecharge?.paymentStatus === "paid") {
          sessionStorage.removeItem("qrispid");
          window.location.href = "/payment/success";
        } else {
          sessionStorage.removeItem("qrispid");
          window.location.href = "/payment/failed";
        }
      })
      .catch((err) => {
        sessionStorage.removeItem("qrispid");
        window.location.href = "/payment/failed";
      });
  }, []);

  return <Loader />;
}
